import { Link } from "react-router-dom";
import Footer from "../../Layouts/Footer";

const Privacy = () => {
  return (
    <>
      {/* <Header /> */}
      <div id="ajax-content-wrap">
        <div className="breadcrumb">
          <span>
            <span>
              <Link to="/">Home</Link> /{" "}
              <span className="breadcrumb_last" aria-current="page">
                Privacy Policy{" "}
              </span>
            </span>
          </span>{" "}
        </div>
        <div
          id="page-header-wrap"
          data-animate-in-effect="none"
          data-midnight="light"
          className=""
          style={{ height: "250px" }}
        >
          <div
            id="page-header-bg"
            className="not-loaded "
            data-padding-amt="low"
            data-animate-in-effect="none"
            data-midnight="light"
            data-text-effect="rotate_in"
            data-bg-pos="center"
            data-alignment="center"
            data-alignment-v="middle"
            data-parallax="0"
            data-height="250"
            style={{ backgroundColor: "#e8f5e5", height: "250px" }}
          >
            <div className="container">
              <div className="row">
                <div className="col span_6 ">
                  <div className="inner-wrap">
                    <h1 className="top-heading">
                      <span className="wraped">
                        <span
                          style={{
                            transform: "rotateX(0deg) translate(0px)",
                            opacity: 1,
                            color: "black",
                          }}
                        >
                          Privacy
                        </span>
                      </span>{" "}
                      <span className="wraped">
                        <span
                          style={{
                            transform: "rotateX(0deg) translate(0px)",
                            opacity: 1,
                            color: "black",
                          }}
                        >
                          Policy
                        </span>
                      </span>
                    </h1>{" "}
                    <span
                      className="subheader"
                      style={{
                        transform: "rotateX(0deg) translate(0px)",
                        opacity: 1,
                      }}
                    ></span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="container-wrap">
          <div className="container main-content">
            <div className="row">
              <div
                id="about_us"
                data-column-margin="default"
                data-midnight="dark"
                className="wpb_row vc_row-fluid vc_row  vc_row-o-equal-height vc_row-flex   right_padding_85px left_padding_85px right_padding_tablet_65px right_padding_phone_20px left_padding_tablet_65px left_padding_phone_20px "
                style={{ paddingTop: "60px", paddingBottom: "0px" }}
              >
                <div
                  className="row-bg-wrap"
                  data-bg-animation="none"
                  data-bg-overlay="false"
                >
                  <div className="inner-wrap">
                    <div className="row-bg"></div>
                  </div>
                </div>
                <div className="row_col_wrap_12 col span_12 dark left">
                  <div
                    className="vc_col-sm-12 wpb_column column_container vc_column_container col no-extra-padding inherit_tablet inherit_phone "
                    data-padding-pos="all"
                    data-has-bg-color="false"
                    data-bg-color=""
                    data-bg-opacity="1"
                    data-animation=""
                    data-delay="0"
                  >
                    <div className="vc_column-inner">
                      <div className="wpb_wrapper">
                        <div className="wpb_text_column wpb_content_element ">
                          <div className="wpb_wrapper">
                            <p style={{ padding: "0px", textAlign: "left" }}>
                              <span
                                style={{
                                  color: "rgb(33, 37, 41)",
                                  fontSize: "16px",
                                }}
                              >
                                <strong>1. ACCEPTING THESE TERMS</strong>
                              </span>
                            </p>
                            <p>
                              <span style={{ color: "rgb(33, 37, 41)" }}>
                                This document, our rules, policies and the other
                                documents referenced make up our Terms and
                                Conditions (“Terms”). The Terms are a legally
                                binding contract between you and LapOtencielle,
                                LLC. This contract sets out your rights and
                                responsibilities when you use
                                www.lapotencielle.com. Please read them
                                carefully.
                              </span>
                            </p>
                          </div>
                        </div>
                        <div className="wpb_text_column wpb_content_element ">
                          <div className="wpb_wrapper">
                            <p style={{ padding: "0px", textAlign: "left" }}>
                              <span
                                style={{
                                  color: "rgb(33, 37, 41)",
                                  fontSize: "16px",
                                }}
                              >
                                <strong>2. CHANGES</strong>
                              </span>
                            </p>
                            <p>
                              <span style={{ color: "rgb(33, 37, 41)" }}>
                                LapOtencielle, LLC may amend the Terms at any
                                time by posting a revised version on our
                                website. The revised version will be effective
                                at the time we post it.
                              </span>
                            </p>
                          </div>
                        </div>
                        <div className="wpb_text_column wpb_content_element ">
                          <div className="wpb_wrapper">
                            <p style={{ padding: "0px", textAlign: "left" }}>
                              <span
                                style={{
                                  color: "rgb(33, 37, 41)",
                                  fontSize: "16px",
                                }}
                              >
                                <strong>
                                  3. ACCESS
                                  <br />
                                </strong>
                              </span>
                            </p>
                            <p>
                              <span style={{ color: "rgb(33, 37, 41)" }}>
                                You are granted a non-exclusive, limited and
                                revocable license to access the site and use its
                                functionality on the condition that:
                                <br />
                                (a) You are over the age of 18;
                                <br />
                                (b) You only use the site for lawful purposes;
                                <br />
                                (c) You do not engage in any improper, indecent
                                or offensive behavior while using the site; and
                                <br />
                                (d) You are not breaking any law in your
                                relevant jurisdiction by accessing this site.
                              </span>
                            </p>
                          </div>
                        </div>
                        <div className="wpb_text_column wpb_content_element ">
                          <div className="wpb_wrapper">
                            <p style={{ padding: "0px", textAlign: "left" }}>
                              <span
                                style={{
                                  color: "rgb(33, 37, 41)",
                                  fontSize: "16px",
                                }}
                              >
                                <strong>
                                  4. AVAILABILITY OF PRODUCTS
                                  <br />
                                </strong>
                              </span>
                            </p>
                            <p>
                              <span style={{ color: "rgb(33, 37, 41)" }}>
                                All product orders are subject to availability.
                                Along this line, if there are difficulties
                                regarding the supply of products or there are no
                                more items left in stock, we will let you know
                                in advance.
                              </span>
                            </p>
                          </div>
                        </div>
                        <div className="wpb_text_column wpb_content_element ">
                          <div className="wpb_wrapper">
                            <p style={{ padding: "0px", textAlign: "left" }}>
                              <span
                                style={{
                                  color: "rgb(33, 37, 41)",
                                  fontSize: "16px",
                                }}
                              >
                                <strong>
                                  5. PRICE AND PAYMENT
                                  <br />
                                </strong>
                              </span>
                            </p>
                            <p>
                              <span style={{ color: "rgb(33, 37, 41)" }}>
                                5.1 The price of the products will be as
                                stipulated at all times on our website, except
                                in the case of an obvious error. Although we
                                make every effort to ensure that the prices
                                featured on the website are correct, error may
                                occur. If we discover an error in the price of
                                any of the products that you have ordered, we
                                will inform you as soon as possible and give you
                                the option of confirming your order at the
                                correct price or cancelling it. If we are unable
                                to contact you, the order will be considered
                                cancelled and all amounts paid will be
                                reimbursed to you in full.
                              </span>
                            </p>
                            <p>
                              5.2 Prices may change at any time. Once you have
                              selected all articles that you wish to buy, they
                              will be added to your basket. The next step will
                              be to process the order and make the payment. To
                              that end, you must follow the steps of the
                              purchase process, indicating or verifying the
                              information requested in each step. Furthermore,
                              throughout the purchase process, before payment,
                              you can modify the details of your order.
                            </p>
                            <p>
                              5.3 Credit cards are subject to verification and
                              authorization by the card issuing entity. If the
                              entity does not authorize the payment, we shall
                              not be liable for any delay or failure to deliver
                              and we will be unable to conclude any Contract
                              with you.
                            </p>
                          </div>
                        </div>
                        <div className="wpb_text_column wpb_content_element ">
                          <div className="wpb_wrapper">
                            <p style={{ padding: "0px", textAlign: "left" }}>
                              <span
                                style={{
                                  color: "rgb(33, 37, 41)",
                                  fontSize: "16px",
                                }}
                              >
                                <strong>
                                  5. PRICE AND PAYMENT
                                  <br />
                                </strong>
                              </span>
                            </p>
                            <p>
                              <span style={{ color: "rgb(33, 37, 41)" }}>
                                5.1 The price of the products will be as
                                stipulated at all times on our website, except
                                in the case of an obvious error. Although we
                                make every effort to ensure that the prices
                                featured on the website are correct, error may
                                occur. If we discover an error in the price of
                                any of the products that you have ordered, we
                                will inform you as soon as possible and give you
                                the option of confirming your order at the
                                correct price or cancelling it. If we are unable
                                to contact you, the order will be considered
                                cancelled and all amounts paid will be
                                reimbursed to you in full.
                              </span>
                            </p>
                            <p>
                              5.2 Prices may change at any time. Once you have
                              selected all articles that you wish to buy, they
                              will be added to your basket. The next step will
                              be to process the order and make the payment. To
                              that end, you must follow the steps of the
                              purchase process, indicating or verifying the
                              information requested in each step. Furthermore,
                              throughout the purchase process, before payment,
                              you can modify the details of your order.
                            </p>
                            <p>
                              5.3 Credit cards are subject to verification and
                              authorization by the card issuing entity. If the
                              entity does not authorize the payment, we shall
                              not be liable for any delay or failure to deliver
                              and we will be unable to conclude any Contract
                              with you.
                            </p>
                          </div>
                        </div>
                        <div className="wpb_text_column wpb_content_element ">
                          <div className="wpb_wrapper">
                            <p style={{ padding: "0px", textAlign: "left" }}>
                              <span
                                style={{
                                  color: "rgb(33, 37, 41)",
                                  fontSize: "16px",
                                }}
                              >
                                <strong>
                                  6. REFUSAL TO PROCESS AN ORDER
                                  <br />
                                </strong>
                              </span>
                            </p>
                            <p>
                              <span style={{ color: "rgb(33, 37, 41)" }}>
                                LapOtencielle, LLC reserves the right to remove
                                any product from this website at any time and to
                                remove or modify any material or content from
                                the same. We reserve the right to do so at any
                                time.
                                <br />
                              </span>
                            </p>
                          </div>
                        </div>
                        <div className="wpb_text_column wpb_content_element ">
                          <div className="wpb_wrapper">
                            <p style={{ padding: "0px", textAlign: "left" }}>
                              <span
                                style={{
                                  color: "rgb(33, 37, 41)",
                                  fontSize: "16px",
                                }}
                              >
                                <strong>7. PROHIBITED USES</strong>
                              </span>
                            </p>
                            <p>
                              <span style={{ color: "rgb(33, 37, 41)" }}>
                                You may not use, or encourage, promote,
                                facilitate, instruct or induce others to use,
                                the website or website services for any
                                activities that violate any law, statute,
                                ordinance or regulation; for any other illegal
                                or fraudulent purpose or any purpose that is
                                harmful to others; or to transmit, store,
                                display, distribute or otherwise make available
                                content that is illegal, fraudulent or harmful
                                to others.
                              </span>
                            </p>
                          </div>
                        </div>
                        <div className="wpb_text_column wpb_content_element ">
                          <div className="wpb_wrapper">
                            <p style={{ padding: "0px", textAlign: "left" }}>
                              <span
                                style={{
                                  color: "rgb(33, 37, 41)",
                                  fontSize: "16px",
                                }}
                              >
                                <strong>8. TERMINATION</strong>
                              </span>
                            </p>
                            <p>
                              <span style={{ color: "rgb(33, 37, 41)" }}>
                                8.1 LapOtencielle, LLC reserves the right to
                                change, suspend, limit or discontinue any of its
                                services, in whole or in part at any time for
                                any reason, without notice (unless required by
                                law). 8.2 LapOtencielle, LLC may refuse service
                                to anyone and may terminate or suspend your
                                services and your access to the website in whole
                                or in part at any time, for any reason, without
                                notice (unless required by law).
                              </span>
                            </p>
                          </div>
                        </div>
                        <div className="wpb_text_column wpb_content_element ">
                          <div className="wpb_wrapper">
                            <p style={{ padding: "0px", textAlign: "left" }}>
                              <span
                                style={{
                                  color: "rgb(33, 37, 41)",
                                  fontSize: "16px",
                                }}
                              >
                                <strong>9. LIMITATIONS</strong>
                              </span>
                            </p>
                            <p>
                              <span style={{ color: "rgb(33, 37, 41)" }}>
                                In no event will LapOtencielle, LLC be liable to
                                you for any indirect, incidental, special,
                                consequential or punitive damages (including
                                damages for loss of profits, goodwill, or any
                                other intangible loss) arising out of or
                                relating to your access to or use of, or your
                                inability to access or use, the website or any
                                materials or content available through the
                                website, whether based on warranty, contract,
                                tort (including negligence), statute, or any
                                other legal theory, and whether or not
                                LapOtencielle, LLC has been informed of the
                                possibility of damage.
                              </span>
                            </p>
                          </div>
                        </div>
                        <div className="wpb_text_column wpb_content_element ">
                          <div className="wpb_wrapper">
                            <p style={{ padding: "0px", textAlign: "left" }}>
                              <span
                                style={{
                                  color: "rgb(33, 37, 41)",
                                  fontSize: "16px",
                                }}
                              >
                                <strong>10. INDEMNIFICATION</strong>
                              </span>
                            </p>
                            <p>
                              <span style={{ color: "rgb(33, 37, 41)" }}>
                                You agree that you will be responsible for your
                                use of the website, and you agree to defend and
                                indemnify LapOtencielle, LLC from and against
                                every claim, liability, damage, loss, and
                                expense, including reasonable attorneys’ fees
                                and costs, arising out of or in any way
                                connected with: (i) your access to, use of, or
                                alleged use of, the website; (ii) your violation
                                of any portion of these Terms, any
                                representation, warranty, or agreement
                                referenced in these Terms, or any applicable law
                                or regulation; (iii) your violation of any third
                                party right, including any intellectual property
                                right or publicity, confidentiality, other
                                property, or privacy right; or (iv) any dispute
                                or issue between you and any third party.
                              </span>
                            </p>
                          </div>
                        </div>
                        <div className="wpb_text_column wpb_content_element ">
                          <div className="wpb_wrapper">
                            <p style={{ padding: "0px", textAlign: "left" }}>
                              <span
                                style={{
                                  color: "rgb(33, 37, 41)",
                                  fontSize: "16px",
                                }}
                              >
                                <strong>11. GOVERNING LAW</strong>
                              </span>
                            </p>
                            <p>
                              <span style={{ color: "rgb(33, 37, 41)" }}>
                                This Terms and Conditions Policy shall be
                                construed in accordance with the laws of the
                                state of Maryland, without reference to its
                                conflict of law provisions, and the obligations,
                                rights and remedies of the parties hereunder
                                shall be determined in accordance with such
                                laws.
                              </span>
                            </p>
                          </div>
                        </div>
                        <div className="wpb_text_column wpb_content_element ">
                          <div className="wpb_wrapper">
                            <p style={{ padding: "0px", textAlign: "left" }}>
                              <span
                                style={{
                                  color: "rgb(33, 37, 41)",
                                  fontSize: "16px",
                                }}
                              >
                                <strong>12. ENTIRE AGREEMENT</strong>
                              </span>
                            </p>
                            <p>
                              <span style={{ color: "rgb(33, 37, 41)" }}>
                                This Agreement contains the entire agreement and
                                understanding among the parties hereto with
                                respect to the subject matter hereof, and
                                supersedes all prior and contemporaneous
                                agreements, understandings, inducements and
                                conditions, express or implied, oral or written,
                                of any nature whatsoever with respect to the
                                subject matter hereof.
                              </span>
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <Footer />
        {/* Footer  */}
      </div>
    </>
  );
};

export default Privacy;
